import { useState, type ReactNode } from 'react'
import { Icon } from './ui'

/**
 * Sezione della scheda contratto: titolo con riga, si apre e si chiude. I figli restano montati anche da chiusa
 * (caricano i loro dati come prima); l'ultima scelta resta nel browser per sezione.
 */
export function ContractSection({ id, title, hint, icon, defaultOpen = true, children }: {
  id: string
  title: string
  hint?: string | undefined
  icon: string
  defaultOpen?: boolean | undefined
  children: ReactNode
}) {
  const key = `ecrm.contract.section.${id}`
  const [open, setOpen] = useState(() => {
    try {
      const saved = localStorage.getItem(key)
      return saved === null ? defaultOpen : saved === '1'
    } catch { return defaultOpen }
  })
  return (
    <details className="ecrm-cs" id={`sezione-${id}`} open={open}
      onToggle={e => {
        const next = (e.currentTarget as HTMLDetailsElement).open
        setOpen(next)
        try { localStorage.setItem(key, next ? '1' : '0') } catch { /* solo comodità */ }
      }}>
      <summary className="ecrm-cs__head">
        <Icon name={icon} size={20} className="ecrm-cs__icon" />
        <span className="ecrm-cs__title">{title}</span>
        {hint ? <span className="ecrm-cs__hint">{hint}</span> : null}
        <Icon name="expand_more" size={20} className="ecrm-cs__chevron" />
      </summary>
      <div className="ecrm-cs__body">{children}</div>
    </details>
  )
}
